import React, { useState } from "react";
import RequestService from "../../../services/request.service";

// import AuthService from "../../../features/auth/auth.service";

import { Button, Modal } from 'react-bootstrap'

import Dialog from '../../../services/Dialogs'


import { toast } from 'react-toastify'


import * as XLSX from 'xlsx';


const ModalInformeAseguramiento = (props) => {


  // const currentUser  = AuthService.getCurrentUser();

  const dialog = new Dialog()

  const { showModal, handleClose } = props

  const [ archivo_subir, setArchivoSubir ] = useState<any>([])

  const handleUpload = (e) => {
      e.preventDefault();

      var files = e.target.files, f = files[0];
      var reader = new FileReader();
      reader.onload = function (e:any) {
          var data : any = e.target.result;
          let readedData = XLSX.read(data, {type: 'binary'});
          const wsname = readedData.SheetNames[0];
          const ws = readedData.Sheets[wsname];

          /* Convert array to json*/
          const dataParse = XLSX.utils.sheet_to_json(ws, {header:1});
          setArchivoSubir(dataParse);
      };
      reader.readAsBinaryString(f)
      return false
  }



const enviarVerificacionMasiva = async(e) => {

  try{

  await dialog.open({
    accept: 'Si',
    cancel : "No",
    dialogClass: '',
    message: 'Un momento',
    // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
    // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
    target: e.target,
    template: `<p>¿Toda la información es correcta?</p>`
  })
  let dialogo : any = await dialog.waitForUser()

  if (dialogo) {
    
    let res = await RequestService.create('aseguramiento/informe_aseguramiento', { tramites_masivo : archivo_subir })
    if(res.data){
      if(res.data.errores.length > 0){
        for (var i = 0; i < res.data.errores.length; ++i) {
          toast.warning('El UUID '+res.data.errores[i][0]+' no se logro informar el aseguramiento . Verifique su información.')
        }
      }
      handleClose()
      toast.success('La Carga Masiva se realizo correctamente')
    }
    else{
      toast.error('Error al migrar la informacion')
    }
    
  }




  }
  catch(e){
    toast.error('Error al cargar la verificación masiva')
  }
}


  return (

      <React.Fragment>
        
              <Modal size={'lg'} show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Informe de Aseguramiento</Modal.Title>
                </Modal.Header>
                <Modal.Body>

  <div className="mb-3">
    <label htmlFor="archivo" className="form-label">Selecciona el Layout</label>
    <input type="file" className="form-control" onChange={handleUpload} accept=".xlsx" id="archivo" />
  </div>
                  

                    

                    {
                      // JSON.stringify(archivo_subir)
                    }

                    {

                      archivo_subir.length > 0 && (

                          <React.Fragment>


                              <table className="table table-sm">
                                <thead style={{fontSize:10}}>
                                  <tr>
                                    <th scope="col">KEY</th>
                                    <th scope="col">CURP</th>
                                    <th scope="col">Fecha de Alta</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    archivo_subir.map( (registro,index) =>

                                        <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                          
                                          {
                                            index > 0 && (

                                                <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                  <td width={180}>
                                                    <small style={{fontSize:6}}>{registro[0]}</small>
                                                  </td>
                                                  <td className="v">
                                                    <small>{registro[1]}</small>
                                                  </td>
                                                  <td className="v" width={100}>
                                                    <small>{registro[2]}</small>
                                                  </td>
                                                </tr>

                                            )
                                          }

                                        </React.Fragment>


                                    )
                                  }

                                </tbody>
                              </table>





                          </React.Fragment>

                      )


                    }


                </Modal.Body>
                <Modal.Footer>
                  <Button variant="danger" onClick={handleClose}>
                    Cancelar
                  </Button>

                    {

                      archivo_subir.length > 0 && (

                          <Button variant="success" onClick={enviarVerificacionMasiva}>
                            Reportar Aseguramiento
                          </Button>

                      )
                   }


                </Modal.Footer>
              </Modal>



      </React.Fragment>


    )



}


export default ModalInformeAseguramiento